export const INVALID_EMAIL_ERROR = 'Please enter a valid email address';
